/* Tiny coloured KPI tile used inside BvsmResultCard. Internal to /dashboard. */

const TONES = {
  slate: "border-slate-200 bg-slate-50 text-slate-700",
  amber: "border-amber-200 bg-amber-50 text-amber-800",
  rose: "border-rose-200 bg-rose-50 text-rose-800",
  violet: "border-violet-200 bg-violet-50 text-violet-800",
  cyan: "border-cyan-200 bg-cyan-50 text-cyan-800",
  blue: "border-blue-200 bg-blue-50 text-blue-800",
};

export default function MiniKpi({ label, value, tone = "slate" }) {
  return (
    <div className={`rounded-md border p-2.5 ${TONES[tone] || TONES.slate}`}>
      <div className="text-[10px] uppercase tracking-wider font-medium opacity-80">{label}</div>
      <div className="text-sm font-semibold mt-0.5 truncate">{value}</div>
    </div>
  );
}
